import { Link } from 'react-router';

import { cn } from '@/lib/utils';

import type { LinkedDoc } from './types';

/**
 * A pill beside the detail header that OPENS another document in the chain
 * (BR-SAL-02-08: the invoice pill opens the invoice). `muted` is provenance
 * — "From QT-0012"; `blue` is the document this one produced.
 */
export function LinkedDocChip({ doc }: { doc: LinkedDoc }) {
  const Icon = doc.icon;
  return (
    <Link
      to={doc.to}
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium',
        doc.tone === 'blue'
          ? 'bg-blue-100 text-blue-800 hover:underline dark:bg-blue-950 dark:text-blue-300'
          : 'bg-muted text-muted-foreground hover:text-foreground',
      )}
    >
      {Icon ? <Icon className="size-3" aria-hidden /> : null}
      {doc.label}
    </Link>
  );
}
